<i18n>
{
	"en": {
		"date": "Date",
		"time": "Time",
		"timeNotSet": "Time is a mandatory field",
		"invalidDateObject": "Invalid date",
		"date1IsNotBeforeDate2": "Planned departure is before planned arrival."
	},
	"no": {
		"date": "Dato",
		"time": "Tid",
		"timeNotSet": "Tidspunkt er påkrevd",
		"invalidDateObject": "Ugyldig dato",
		"date1IsNotBeforeDate2": "Planlagt avgang er før planlagt ankomst."
	}
}
</i18n>

<template>
	<div class="datetime-wrapper">
		<TFormGroup :title="title" horizontal useMinWidth>
			<TDatePicker
				useMinWidth
				disableButtonTabbing
				:placeholder="$t('date')"
				:value="date"
				:dateFormat="displayDateFormat"
				@input="onDateInput"
			/>
			<TTimePicker
				v-if="!noTime"
				useMinWidth
				disableButtonTabbing
				:placeholder="$t('time')"
				:value="time"
				@input="onTimeInput"
			/>
		</TFormGroup>
		<div v-if="isInvalid" class="validation-error">
			<TTimpexIcon
				class="icon"
				icon="error"
				type="bp"
				size="xs"
			/>
			<p class="text">{{generatedValidationMessage}}</p>
		</div>
	</div>
</template>

<script>
import {
	displayDateFormat,
	displayDateFormatter,
	storageDateFormat,
} from '@/core';
import moment from 'moment';

import TDatePicker from '@/components/evergreen/inputs/TDatePicker';
import TTimePicker from '@/components/evergreen/inputs/TTimePicker';
import TTimpexIcon from '../icons/TTimpexIcon';
import TFormGroup from './TFormGroup';

export default {
	name: 'TDateTimeInput',
	components: {
		TDatePicker,
		TTimePicker,
		TTimpexIcon,
		TFormGroup,
	},

	props: {
		dateTimeObject: {
			type: Object,
		},
		title: String,
		isInvalid: Boolean,
		validationMessage: String,
		validationKey: [String, Boolean],
		noTime: Boolean,
	},

	computed: {
		displayDateFormat: () => displayDateFormat,
		dateTimeIsEmpty() {
			if (!this.dateTimeObject) return true;
			return Object.keys(this.dateTimeObject).length === 0;
		},
		date() {
			if (this.dateTimeIsEmpty) return undefined;
			return displayDateFormatter(this.dateTimeObject.date);
		},
		time() {
			if (this.dateTimeIsEmpty) return null;
			if (!this.dateTimeObject.hasTime) return null;

			return this.dateTimeObject.date ?
				moment(this.dateTimeObject.date, storageDateFormat).format('LT') :
				undefined;
		},
		generatedValidationMessage() {
			return this.validationKey ? this.$t(this.validationKey) : this.validationMessage;
		},
	},

	methods: {
		displayDateFormatter,
		onDateInput(value) {
			this.$emit('date-input', value);
		},
		onTimeInput(value) {
			this.$emit('time-input', value);
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.datetime-wrapper {
	display: grid;
	grid-template-columns: min-content;
	align-content: start; /* Allways keep error message right below inputs */
}

.validation-error {
	@extend %font-families-ui;
	margin-top: 8px;
	display: inline-flex;
	align-items: center;
	color: get-color($red, 'base');
	&>.icon {
		color: inherit;
		height: 14px;
		width: 14px;
		margin-right: 6px;
	}
	&>.text {
		@extend %text-small;
		box-sizing: border-box;
		line-height: 18px;
		margin-top: 0;
		margin-bottom: 0;
	}
}
</style>
